import styled from 'styled-components'

const PageTitle = styled.h2`
  margin: 0 0 30px;
  color: ${(p) => p.theme.FONT_COLOR};
  font-weight: 700;
  font-size: ${(p) => p.theme.font.size.xxl};
  line-height: 30px;
  text-align: center;
`

export default PageTitle
